import mixpanel from 'mixpanel-browser';

export const initializeMixpanel = () => {
  try {
    mixpanel.init(String(process.env.REACT_APP_MIX_PANEL_TOKEN), {
      debug: String(process.env.REACT_APP_DEV_ENV) === 'qa',
    });
  } catch (error) {
    console.error('ERROR: While initialisation of mix panel', error);
  }
};

export const updateUser = (userData: any) => {
  try {
    mixpanel.alias(userData.userId);
    mixpanel.people.set({ $email: userData.email, ...userData });
  } catch (error) {
    console.error('ERROR: While updating user of mix panel', error);
  }
};

export const fireEvent = (eventName: string, properties?: Record<string, any>) => {
  if (!eventName) {
    console.error('Event name is required to fire a Mixpanel event');
    return;
  }
  mixpanel.track(eventName, properties);
};
export const identifyUser = (userId: string) => {
  try {
    mixpanel.identify(userId);
    mixpanel.people.set({ $email: userId });
  } catch (error) {
    console.error('ERROR: While identifying user of mix panel', error);
  }
};
// mixpanel.identify(uniqueId);
// if (!uniqueId.includes('anon')) mixpanel.people.set({ $email: uniqueId });

// ? Creates a scheduled event trigger with caching functionality
// ? @param delay - Delay in milliseconds before triggering the event (default: 10000ms = 10sec)
// ? @returns A function that schedules the event with debouncing

export const createScheduledEvent = (delay = 10000) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  let cachedParams: any[] = [];

  return (trackingFunction: (...args: any[]) => void, ...args: any[]) => {
    // Clear existing timeout if it exists
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // Update cached parameters with new values
    cachedParams = args;

    // Set new timeout to trigger the event after the delay
    timeoutId = setTimeout(() => {
      trackingFunction(...cachedParams);
      timeoutId = null;
      cachedParams = [];
    }, delay);
  };
};
